import React, {Fragment} from "react";
import {Row, Col, FormGroup, Label} from "reactstrap";
import {FormCheck} from "react-bootstrap";


const ProductTypeForm = (props) => {
    const {
        errors,
        control,
        register,
        setValue,
        trigger,
        getValues,
        searchSellersByName,
        sellers,
        setOptions,
        promiseOptions
    } = props;

    return (
        <Fragment>
            <Row>
                <Col>
                   <FormGroup>
                       <Label className="col-form-label">Product Type Name</Label>
                       <input name="name" type="text" {...register('name')} className={`form-control ${errors.name ? 'is-invalid' : ''}`}/>
                       <div className="invalid-feedback">{errors.name?.message}</div>
                   </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Tag Name</Label>
                        <input name="tageName" type="text" {...register('tagName')} className={`form-control ${errors.tagName ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.tagName?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
        </Fragment>
    );
};

export default ProductTypeForm;